import $ from '../vendor/jquery';
import Headroom from '../vendor/headroom';

$(".page-header").each(function () {
  var hrMain = new Headroom(this, {
    offset: 0,
    tolerance: 0
  });
  hrMain.init();
});



// WEBPACK FOOTER //
// ./public/assets/js/src/components/header.js